module.exports = __webpack_public_path__ + "img/Oracle_round.3cabffaf.png";